<div class="tasks-container">
	<app-spin-or-content [isSpin]="isLoading">
		<div class="task-menu d-flex justify-content-between mb-3">
			<div class="d-flex gap-3">
				<h3>
					<button
						class="btn btn-icon"
						(click)="openCloseAllChats()"
						titleLang="open_close_all_chats"
						[icon]="isAllOpen ? 'arrow_down2' : 'arrow_up2'"
					></button>
				</h3>
				<div class="d-flex">
					@if (
						permsService.perms?.authorized_signer &&
						permsService?.owner_has_users
					) {
						<button
							class="btn btn-icon"
							(click)="modalProps = { name: 'sign-documents' }"
							titleLang="needs_to_be_signed"
						>
							<app-icon
								icon="sign_document"
								className="fa-2x"
							/>
						</button>
					}
					<!--				@if (permsService.perms?.administrative && isPartner) {-->
					<!--					<button-->
					<!--						titleLang="show_motions"-->
					<!--						tabindex="-1"-->
					<!--						class="btn btn-primary"-->
					<!--						(click)="modalProps={name:'mr-motions'}"-->
					<!--						preIcon="partner"-->
					<!--					>-->
					<!--						<span> {{ "show_motions" | langVal }}</span>-->
					<!--					</button>-->
					<!--				}-->
					<button
						titleLang="meeting_requests"
						tabindex="-1"
						class="btn btn-primary"
						(click)="modalProps = { name: 'meeting-requests' }"
					>
						<span> {{ "meeting_requests_list" | langVal }}</span>
					</button>
					<button
						titleLang="task-schedules"
						tabindex="-1"
						class="btn btn-primary"
						(click)="modalProps = { name: 'taskschedules' }"
					>
						<span> {{ "task_schedules" | langVal }}</span>
					</button>
				</div>
			</div>
			@if (showAddTask) {
				<app-add-task
					(saved)="handleFinishedNewTask()"
					(onSchedulerClose)="handleSchedulerClose($event)"
					[patientRow]="patientRow"
				/>
			}
		</div>
		<hr />
		<div class="cards-list">
			@for (task of openTasks; track task) {
				<div class="card-container">
					<div
						titleLang="task"
						class="card-wrapper w-100"
					>
						<!-- <div class="action-fields">
              <button
                (click)="openCloseChat(task)"
                class="btn btn-icon"
                [icon]="task.chat_open ? 'narrow' : 'expand'"
                titleLang="expand"
              ></button>
            </div> -->
						<div class="card-check">
							<app-check
								titleLang="close_task"
								(onClick)="openCloseTask(task)"
								[isCheck]="task.closed == 'yes'"
							/>

							<!--<label (click)="openCloseTask(task)">{{ "close_task" | langVal }}</label>  -->
						</div>
						<div class="card-details">
							@if (permsService?.owner_has_users) {
								@if (task.sender) {
									<div class="userName d-flex align-items-center gap-2 w-100">
										<div>{{ "from" | langVal }}: {{ task.sender }}</div>
										<div
											class="d-flex gap-1 recipient-list"
											style="
												flex-grow: 1;
												border: 1px solid var(--light-grey);
												border-radius: 4px;
												background: var(--very-light-grey);
												padding: 2px 6px;
											"
										>
											<div>{{ "recipients" | langVal }}:</div>

											@for (
												recipient of task.recipients
													| slice: 0 : (task?.allRecipients ? 999999999999 : 3);
												track recipient
											) {
												<div
													class="recipient"
													[class.uptodate]="
														$any(recipient).is_uptodate == 'yes'
													"
												>
													{{ $any(recipient).name }}
												</div>
											}
										</div>
									</div>
								}
							}
							<div class="card-title d-flex">
								@if (inquiry_statuses_names[task.inquiry_status_id]) {
									<div
										titleLang="inquiry_status"
										class="card-status"
									>
										{{ inquiry_statuses_names[task.inquiry_status_id] || "" }}
									</div>
								}
								<div>
									{{ task.content }}
								</div>
							</div>
							<div class="d-flex p-0">
								<!-- @if (task.date == today) { -->
								<label titleLang="time"
									>{{ task.created_at | localtime }}
								</label>
								<!-- } -->
								<label>|</label>

								<label
									titleLang="do_date"
									class="d-flex gap-1"
									><b>
										{{ task.date | dateFormat }}
									</b>
								</label>
							</div>
						</div>
					</div>
					<div class="comments-container">
						@for (
							commentsOrMotion of task.commentsOrMotions;
							track commentsOrMotion
						) {
							<div
								class="comment-wrapper"
								[class.mine]="commentsOrMotion.isMine"
							>
								<div
									class="userName"
									[style.background]="commentsOrMotion.color"
								>
									{{ commentsOrMotion.userName }}
								</div>
								<div class="d-flex gap-1 align-items-end">
									<div
										class="comment"
										[style.border-color]="commentsOrMotion.color"
									>
										<!-- <div
                    class="comment-motion-content"
                    (click)="openCloseChat(task)"
                    > -->
										<div>
											@if (commentsOrMotion?.status) {
												<span class="label label-primary hey">
													{{ commentsOrMotion.status }}
												</span>
											}
											@if (commentsOrMotion?.actor) {
												<span class="label label-primary">
													{{ commentsOrMotion.actor }}
												</span>
											}
											{{ commentsOrMotion.content }}
										</div>
										<div
											class="d-flex gap-1"
											style="justify-self: flex-end"
										>
											<!-- @if (task.date == today) { -->
											<label titleLang="time"
												>{{ task.time | timeFormat }}
											</label>
											<!-- } -->
											<label>|</label>

											<label
												titleLang="do_date"
												class="d-flex gap-1"
												><b>
													{{ task.date | dateFormat }}
												</b>
											</label>
										</div>
									</div>
									<!-- <label class="time">{{ commentsOrMotion.datetime }}</label> -->
								</div>
							</div>
						}
						@if (task.chat_open) {
							<div>
								@if (task.recipients.length > 3) {
									<div
										(click)="
											task.allRecipients = !task.allRecipients;
											$event.stopPropagation()
										"
										class="ellipsis"
									>
										...
									</div>
								}
							</div>

							@if (task.closed == "no") {
								<div class="new-comment">
									<div
										class="d-flex gap-2 flex-nowrap justify-content-end align-items-end"
										style="
											border: 1px solid var(--light-grey);
											max-width: 90%;
											margin-inline: auto 0;
											background: white;
											border-radius: 4px;
										"
									>
										<div class="w-100">
											<app-gen-input
												[tabindex]="`${tabindexStart + $index * 10}`"
												[actualObj]="task"
												fieldName="newComment"
												type="textarea"
												title_ph_lang="comment"
											>
											</app-gen-input>
										</div>
										<div>
											<app-btn-ext
												[disabled]="
													!task.newComment &&
													(task.new_inquiry_status_id == 0 ||
														task.inquiry_status_id ==
															task.new_inquiry_status_id)
												"
												btnClass="primary submit-comment"
												[tabindex]="`${tabindexStart + $index * 10 + 1}`"
												[isSpin]="task.commentSending"
												(clickEv)="addCommentAndStatus(task)"
												iconName="send"
											/>
										</div>
									</div>

									@if (
										task?.task_type == "inquiry" &&
										permsService?.perms?.administrative &&
										permsService.owner_has_users
									) {
										<div class="d-flex gap-3 flex-wrap">
											<div>
												<label> {{ "assign_to_assoc" | langVal }}:</label>
												<div>
													<app-autocomplete-multi
														siteDataTable="sub_users"
														[siteDataFilters]="{ active: 'yes' }"
														[ids]="task.patientAssoc"
														(addItem)="assocAddItem($event, task)"
														(deleteItem)="assocDeleteItem($event, task)"
														[excludeIds]="excludeIds"
													/>
												</div>
											</div>
											<div>
												<label> {{ "assign_recipient" | langVal }}:</label>
												<div>
													<app-autocomplete-multi
														[ids]="task.recipientIds"
														(addItem)="recipientAddItem($event, task)"
														[excludeIds]="[task.user_id]"
														siteDataTable="sub_users"
														[siteDataFilters]="{ active: 'yes' }"
														(deleteItem)="recipientDeleteItem($event, task)"
													/>
												</div>
											</div>
										</div>
									}
								</div>
							}
						}
						<div class="mis-auto">
							<app-btn-ext
								iconName="plus"
								(click)="openCloseChat(task)"
							/>
						</div>
						<!-- card-actions-bottom -->
						<div
							class="d-flex align-content-center gap-1 justify-content-between my-2"
						>
							@if (permsService?.owner_has_users) {
								@if (task.commentsOrMotions?.length) {
									@if (task.is_uptodate == "no") {
										<app-btn-ext
											text="set_is_uptodate"
											(clickEv)="setIsUptodate(task)"
										/>
									}
								}
							}
							@if (task.patient_id || task.contact_id) {
								<button
									titleLang="patient_or_contact"
									[class.card-patient.btn]="!!task.patient_id"
								>
									<app-patient-modal
										[id]="task.patient_id"
										[openInTests]="task?.task_type === 'patient_test_fill'"
									>
										{{ "patient_file" | langVal }}:

										<b>{{ task.person }}</b>
									</app-patient-modal>
								</button>
							}
							<div class="d-flex gap-1 mis-auto">
								@if (task?.task_type == "inquiry") {
									<app-btn-ext
										text="irrelevant"
										[disabled]="task.inquiry_status_id == -6"
										(clickEv)="changeToIrrelevant(task)"
									/>
								}
								@if (task?.meeting_request) {
									@if (task.meeting_request.date) {
										<app-btn-ext
											text="insert_calendar_item_or_invoice"
											(clickEv)="schedMeeting(task)"
										/>
									} @else {
										<app-btn-ext
											text="to_insert_patient_form"
											(clickEv)="openNewPatient(task.meeting_request)"
										/>
									}
								}
								@if (task?.meeting_request?.id) {
									@if (task.meeting_request.date) {
										<app-btn-ext
											text="deactivate_meeting_request"
											(clickEv)="deactivateMeetingRequest(task)"
											[isSpin]="task.deactivateSpin"
										/>
									}
								}
								@if (task?.context) {
									<app-btn-ext
										text="insert_calendar_item_or_invoice"
										(clickEv)="openContext(task)"
									/>
								}
								@if (
									task?.task_type == "patient_details_fill" &&
									permsService?.perms?.administrative
								) {
									<app-btn-ext
										text="update_from_patient_form"
										[isSpin]="isApprovingPatientDetails"
										(clickEv)="
											isApprovingPatientDetails = true;
											store.sendFillDetailsApprove(task.patient_id);
											openCloseTask(task)
										"
									/>
								}
								@if (!task?.meeting_request?.id) {
									<app-btn-ext
										text="done"
										(clickEv)="openCloseTask(task)"
									/>
								}
							</div>
						</div>
					</div>
				</div>
			}
		</div>
		<div class="modal-btns flex-column gap-2 align-items-center">
			<app-gen-button-group
				[actualObj]="this"
				fieldName="isShowClosed"
				optionsListName="task_show_closed"
				title_ph_lang="task_show_closed"
				(changeEvent)="handleShowClosedChange()"
			/>
			@if (!patient_id && pageNumbers?.length > 1) {
				<div class="d-flex">
					<button
						class="btn btn-primary"
						(click)="curPage = 0; getTasks()"
						[disabled]="curPage == 0"
					>
						{{ "first" | langVal }}
					</button>
					<button
						class="btn btn-primary"
						(click)="curPage = curPage - 1; getTasks()"
						[disabled]="curPage == 0"
					>
						{{ "previous" | langVal }}
					</button>
					<button
						class="btn btn-primary"
						(click)="curPage = curPage + 1; getTasks()"
						[disabled]="curPage == pageNumbers.length - 1"
					>
						{{ "next" | langVal }}
					</button>
					<button
						class="btn btn-primary"
						(click)="curPage = pageNumbers.length - 1; getTasks()"
						[disabled]="curPage == pageNumbers.length - 1"
					>
						{{ "last" | langVal }}
					</button>
				</div>
			}
		</div>
	</app-spin-or-content>
</div>
@switch (modalProps?.name) {
	@case ("mr-motions") {
		<app-modal-wrap
			(onClose)="modalProps = null; getTasks()"
			hasExit
			title="show_motions"
		>
			<app-mr-motions (onClose)="modalProps = null; getTasks()" />
		</app-modal-wrap>
	}
	@case ("sign-documents") {
		<app-modal-wrap
			(onClose)="modalProps = null; getTasks()"
			title="documents"
		>
			<app-sign-documents (onClose)="modalProps = null; getTasks()" />
		</app-modal-wrap>
	}
	@case ("meeting-requests") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			hasExit
			title="meeting_requests_list"
		>
			<app-meeting-requests (onClose)="onClose.emit()" />
		</app-modal-wrap>
	}
	@case ("taskschedules") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="task_schedules"
		>
			<app-taskschedules (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
	@case ("insert-patient-form") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="insert_patient_form"
			modalWrapperClass="modal-800"
		>
			<app-insert-patient-form
				(onClose)="handleInsertPatientClose($event); modalProps = null"
				hasUpdate
				[meeting_request]="modalProps.meeting_request"
			/>
		</app-modal-wrap>
	}
	@case ("confirm-close") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="close_task_with_meeting_request"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="
					$event ? handleCloseConfirm(modalProps.task) : (modalProps = null)
				"
			/>
		</app-modal-wrap>
	}
}
